<script>
  import Table from "../../components/table/Table.svelte";
  import TableHeader from "../../components/table/TableHeader.svelte";
  import TableHeaderCell from "../../components/table/TableHeaderCell.svelte";
  import TableBody from "../../components/table/TableBody.svelte";
  import TableCell from "../../components/table/TableCell.svelte";
  import TableRow from "../../components/table/TableRow.svelte";
  import EditIconButton from "../../components/IconButtons/EditIconButton.svelte";

  export let headers
  export let rows
</script>

<Table>
  <TableHeader>
    {#each headers as header}
      {#if header.key.startsWith("__")}
        {#if header.key === "__edit"}
          <TableHeaderCell>編集</TableHeaderCell>
        {/if}
      {:else}
        <TableHeaderCell>
          {#if header.name}
            {header.name}
          {:else}
            {header.code}
          {/if}
        </TableHeaderCell>
      {/if}
    {/each}
  </TableHeader>
  <TableBody>
    {#each rows as row}
      <TableRow>
        {#each headers as header}
          {#if header.key.startsWith("__")}
            {#if header.key === "__edit"}
              <TableCell>
                <EditIconButton
                  onClick={() => header.onClick(row)}
                />
              </TableCell>
            {/if}
          {:else}
            <TableCell>
              {#if header.getString}
                {header.getString(row)}
              {:else}
                {row[header.key] ?? ""}
              {/if}
            </TableCell>
          {/if}
        {/each}
      </TableRow>
    {:else}
      <TableRow>
        <TableCell colspan={headers.length}>インポートされたデータがありません。</TableCell>
      </TableRow>
    {/each}
  </TableBody>
</Table>
